/** Default character cap for text shown in a narrow surface (e.g. a menu). */
export const TRUNCATE_TEXT_CAP = 32

/**
 * Truncate text for display in a narrow surface (e.g. a dropdown) so one long
 * string can't blow out the width. Caps at `max` characters and appends an
 * ellipsis; whitespace at the cut is trimmed so we don't render "word …". The
 * full text should still be surfaced elsewhere (e.g. a tooltip).
 *
 * @param {string} text
 * @param {number} [max=TRUNCATE_TEXT_CAP]
 * @return {string}
 */
export function truncateText(text: string, max: number = TRUNCATE_TEXT_CAP): string {
  if (text.length <= max) return text
  return text.slice(0, max).trimEnd() + '…'
}
